var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`btn btn-default ${_vm.additionalClass}`,attrs:{"type":"button","disabled":_vm.disabled,"data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }